var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex flex-wrap align-items-center justify-content-center"},[_c('h1',[_vm._v(" Payment Success ")]),_c('div',{staticClass:"flex-break"}),_c('h1',[_vm._v(" "+_vm._s(_vm.$route.params.id)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }